// src/components/shared/TabPanel.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/**
 * Componente reutilizable para mostrar el contenido de pestañas
 * 
 * @param {Object} props - Propiedades del componente
 * @param {React.ReactNode} props.children - Contenido de la pestaña
 * @param {number} props.value - Valor actual de la pestaña seleccionada
 * @param {number} props.index - Índice de esta pestaña
 * @param {string} props.id - ID del panel para accesibilidad
 * @param {string} props.aria-labelledby - ID del tab que controla este panel
 * @param {Object} props.sx - Estilos adicionales para el contenedor Box
 */
const TabPanel = ({
  children,
  value,
  index,
  id,
  'aria-labelledby': ariaLabelledBy,
  sx = {},
  ...other
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={id}
      aria-labelledby={ariaLabelledBy}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, ...sx }}>
          {children}
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  id: PropTypes.string,
  'aria-labelledby': PropTypes.string,
  sx: PropTypes.object,
};

export default TabPanel;